import {
    Modal,
    Box,
    Grid,
    IconButton,
    Typography,
    Divider,
    CircularProgress,
    Button,
  } from "@material-ui/core";
  import React, { Fragment } from "react";
  import DeleteIcon from "@material-ui/icons/Delete";
  import CloseIcon from "@material-ui/icons/Close";
  import styled from "styled-components";
  
  const ManageTemplatesOrDraftsModal = ({
    bottomToolbarStates,
    setBottomToolbarStates,
    templates,
    populate,
    deleteTemplate,
    isDrafts,
    mailData,
    setMailData,
    openModal,
    isLoadingFetchDrafts
  }) => {
    return (
      <Modal
        open={openModal}
        onClose={() =>
          setBottomToolbarStates({
            ...bottomToolbarStates,
            openManageTemplateModal: false,
            openDraftsModal: false,
            isTemplateModal: false,
          })
        }
      >
        <StyledBox>
          <StyledGrid container alignItems="center">
            <Grid item>
              <Typography variant="h4">
                {isDrafts ? "Select from drafts" : "Manage Templates"}
              </Typography>
            </Grid>
            <Grid item style={{ flex: "1" }}></Grid>
            <Grid item>
              <CloseIcon
                onClick={() =>
                  setBottomToolbarStates({
                    ...bottomToolbarStates,
                    openManageTemplateModal: false,
                    openDraftsModal: false,
                    isTemplateModal: false,
                  })
                }
                style={{ color: "white" }}
              />
            </Grid>
          </StyledGrid>
          <StyledGrid1 container>
            {!isLoadingFetchDrafts ? (
              templates && templates.length > 0 ? (
                templates.map((el) => (
                  <Fragment key={el.id}>
                    <Grid container alignItems="center">
                      <Grid item>
                        <Button
                          onClick={() => {
                            populate(el.id, isDrafts);
                            setBottomToolbarStates({
                              ...bottomToolbarStates,
                              openManageTemplateModal: false,
                              openDraftsModal: false,
                              isTemplateModal: false,
                            });
                          }}
                          variant="contained"
                          color="primary"
                          size="small"
                          className="template-button-useThis"
                          style={{ margin: "5px 0" }}
                        >
                          Use This
                        </Button>
                      </Grid>
                      {!isDrafts && (
                        <Grid item>
                          <IconButton onClick={() => deleteTemplate(el.id)}>
                            <DeleteIcon style={{ color: "red" }} />
                          </IconButton>
                        </Grid>
                      )}
                      <Grid item style={{ padding: "0px 20px 0 10px" }}>
                        <Typography variant="h4">
                          {isDrafts ? (
                            el.subject.length > 0 ? (
                              el.subject
                            ) : (
                              <div style={{ color: "red" }}>NO SUBJECT</div>
                            )
                          ) : (
                            el.name
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider />
                  </Fragment>
                ))
              ) : (
                <StyledBox1>
                  <h5>No templates Found</h5>
                </StyledBox1>
              )
            ) : (
              <StyledBox1>
                <CircularProgress />
              </StyledBox1>
            )}
          </StyledGrid1>
        </StyledBox>
      </Modal>
    );
  };
  
  export default ManageTemplatesOrDraftsModal;
  
  const StyledBox = styled(Box)`
    && {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      min-width: 500px;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
    }
  `;
  
  const StyledGrid = styled(Grid)`
    && {
      padding: 10px 10px 10px 10px;
      background-color: #404040;
      color: white;
    }
  `;
  
  const StyledGrid1 = styled(Grid)`
    && {
      padding: 10px 0 0 5px;
      max-height: 90vh;
      overflow: auto;
    }
  `;
  
  const StyledBox1 = styled(Box)`
    && {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 10px;
    }
  `;